import React from "react";

const SpeakerSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold mb-6">
            Learn from the
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">
              Real Estate Expert
            </span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl overflow-hidden shadow-lg">
            <div className="grid lg:grid-cols-5 gap-0">
              <div className="lg:col-span-2 relative">
                <img
                  src="/images/Bernadette Harris.jpeg"
                  alt="Bernadette Harris - Real Estate Investment Expert"
                  className="w-full h-full object-cover min-h-[400px]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-600/20 to-transparent lg:bg-gradient-to-r"></div>
              </div>

              <div className="lg:col-span-3 p-8 lg:p-12">
                <div className="mb-6">
                  <h3 className="text-3xl font-bold mb-2">Bernadette Harris</h3>
                  <p className="text-xl text-purple-600 font-semibold mb-4">
                    Certified Buyers Agent & Certified Home Advisor
                  </p>

                  <div className="flex flex-wrap gap-2 mb-6">
                    <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-sm font-medium">
                      Certified Buyers Agent
                    </span>
                    <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-sm font-medium">
                      Certified Home Advisor
                    </span>
                    <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-sm font-medium">
                      Team Sales $30M Annually
                    </span>
                  </div>
                </div>

                <div className="space-y-4 mb-8">
                  <p className="text-gray-600 leading-relaxed">
                    Bernadette Harris has helped thousands of clients navigate
                    the home buying process with her expert knowledge and
                    professional certifications. As a Certified Buyers Agent and
                    Certified Home Advisor, she brings unmatched expertise to
                    every transaction, with her team achieving over $30M in
                    annual sales.
                  </p>

                  <div className="space-y-2">
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-purple-600 rounded-full mr-3"></span>
                      <span className="text-gray-700">
                        Certified Buyers Agent (CBA) - Expert in buyer
                        representation
                      </span>
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-purple-600 rounded-full mr-3"></span>
                      <span className="text-gray-700">
                        Certified Home Advisor (CHA) - Specialized home buying
                        guidance
                      </span>
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-purple-600 rounded-full mr-3"></span>
                      <span className="text-gray-700">
                        Team sales exceed $30M annually in real estate
                        transactions
                      </span>
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-purple-600 rounded-full mr-3"></span>
                      <span className="text-gray-700">
                        Expert in first-time home buyer programs and strategies
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4">
                  <a
                    href="https://www.linkedin.com/in/bernadette-harris-7a1299196/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-purple-600 hover:text-purple-700 transition-colors">
                    <svg
                      className="w-5 h-5 mr-2"
                      viewBox="0 0 24 24"
                      fill="currentColor">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                    LinkedIn
                  </a>
                  <a
                    href="https://www.instagram.com/ms.mac.realtor/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-purple-600 hover:text-purple-700 transition-colors">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="w-5 h-5 mr-2">
                      <rect
                        x="2"
                        y="2"
                        width="20"
                        height="20"
                        rx="5"
                        ry="5"></rect>
                      <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path>
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                    Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <blockquote className="text-xl lg:text-2xl font-medium text-gray-600 italic max-w-3xl mx-auto">
            "In just 90 minutes, I'll share the exact strategies that helped our
            clients generate over $2M in real estate profits in their first
            year."
          </blockquote>
          <cite className="text-purple-600 font-semibold mt-4 block">
            - BERNADETTE HARRIS
          </cite>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
